export const course_data={
    bpharma:{
        Course_name:"Diploma in Pharmacy",
        Course_duration:" 2 Years",
        Course_type:"Diploma",
        Course_eligibility:"10+2 with Science stream (Physics, Chemistry, Biology/Mathematics)",
        job_prospects:"Graduates can work as pharmacists, medical representatives, in pharmaceutical companies, hospitals, and retail pharmacies",
        medium_of_exam:"English", 
        Course_description:`D.Pharm, or Diploma in Pharmacy, is a two-year undergraduate diploma program that focuses on pharmaceutical education.
        D.Pharm is designed to provide a solid foundation for individuals aspiring to become pharmacy professionals, such as pharmacists or pharmacy technicians. The curriculum covers subjects like anatomy, physiology, pharmaceutical engineering, and hospital pharmacy, preparing students for roles in retail pharmacies, hospitals, pharmaceutical companies, and other healthcare settings`
        
    }
}